/* frontend/src/pages/Blog.js */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getArticles } from '../utils/api';
import ArticleCard from '../components/ArticleCard';
import AnimatedSocialLinks from '../components/AnimatedSocialLinks';
import './Blog.css';

const Blog = ({ user }) => {
  const { data: articles, isLoading } = useQuery({
    queryKey: ['articles'],
    queryFn: () => getArticles().then((res) => res.data),
  });

  const popularArticles = articles
    ? [...articles].sort((a, b) => b.view_count - a.view_count).slice(0, 3)
    : [];

  return (
    <motion.div
      className="linkedin-blog"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Main Content */}
        <div className="md:col-span-2">
          <motion.h1
            className="text-4xl font-bold mb-6"
            initial={{ y: -20 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.3 }}
          >
            SErraND Blog
          </motion.h1>
          {user && user.is_staff && (
            <Link to="/admin/home/article/add/" className="btn-primary mb-6 inline-block">
              Write New Article
            </Link>
          )}
          {isLoading ? (
            <div className="text-center">Loading...</div>
          ) : articles.length === 0 ? (
            <div className="empty-state">
              <p className="text-lg mb-4">No articles yet.</p>
              {user && user.is_staff && (
                <Link to="/admin/home/article/add/" className="btn-primary">
                  Write the First Article
                </Link>
              )}
            </div>
          ) : (
            articles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))
          )}
        </div>
        {/* Sidebar */}
        <div className="md:col-span-1">
          <motion.div
            className="sidebar bg-gray-800 rounded-lg shadow-md p-6"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h2 className="text-xl font-bold mb-4">Popular Articles</h2>
            {popularArticles.length > 0 ? (
              popularArticles.map((article) => (
                <motion.div
                  key={article.id}
                  className="popular-article mb-4"
                  whileHover={{ x: 5 }}
                >
                  <Link to={`/blog/${article.id}`} className="text-[#0a66c2] hover:underline">
                    {article.title}
                  </Link>
                  <p className="text-sm">
                    {article.view_count} views
                  </p>
                </motion.div>
              ))
            ) : (
              <p className="text-white">No popular articles yet.</p>
            )}
            <hr className="my-4" />
            <h2 className="text-xl font-bold mb-4">Follow Us</h2>
            <AnimatedSocialLinks className="flex flex-col gap-2" />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Blog;
